import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FloralDivider, OrnateDivider } from "@/components/Ornaments";

function getRemaining(iso) {
  const diff = new Date(iso).getTime() - Date.now();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return { days, hours, minutes, seconds };
}

const pad = (n) => String(n).padStart(2, "0");

const CountUnit = ({ value, label, testid }) => (
  <div data-testid={testid} className="gold-frame flex w-16 flex-col items-center bg-white py-3 sm:w-[72px]">
    <span className="relative flex h-8 items-center justify-center overflow-hidden">
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.span
          key={value}
          className="font-display gold-text text-2xl leading-none tabular-nums sm:text-[28px]"
          initial={{ y: 14, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -14, opacity: 0 }}
          transition={{ duration: 0.35 }}
        >
          {pad(value)}
        </motion.span>
      </AnimatePresence>
    </span>
    <span className="mt-1.5 text-[9px] uppercase tracking-[0.2em] text-[#A1A1AA]">{label}</span>
  </div>
);

const Header = ({ data }) => {
  const [t, setT] = useState(() => getRemaining(data.date.iso));

  useEffect(() => {
    const id = setInterval(() => setT(getRemaining(data.date.iso)), 1000);
    return () => clearInterval(id);
  }, [data.date.iso]);

  return (
    <section data-testid="wedding-header" className="space-y-7 text-center">
      <FloralDivider className="opacity-90" />
      <p className="eyebrow">საქორწილო მოსაწვევი</p>
      <h1
        data-testid="couple-names"
        className="font-display whitespace-nowrap text-[clamp(1.6rem,8vw,3rem)] font-semibold leading-tight text-[#1C1917]"
      >
        {data.names.one}
        <span className="font-script gold-text mx-2 align-middle text-[clamp(2rem,10vw,3.8rem)] font-normal">&amp;</span>
        {data.names.two}
      </h1>

      <OrnateDivider />

      <div data-testid="wedding-date-badge" className="gold-frame mx-auto inline-block bg-white px-8 py-4">
        <p className="eyebrow mb-1.5 !text-[9px]">თარიღი</p>
        <p className="font-display gold-text text-lg uppercase tracking-[0.14em] sm:text-xl">
          {data.date.display}
        </p>
      </div>

      <div data-testid="countdown-timer" className="space-y-4 pt-1">
        <p className="eyebrow !text-[10px]">ქორწილამდე დარჩა</p>
        <div className="flex items-stretch justify-center gap-2.5 sm:gap-3.5">
          <CountUnit testid="countdown-days" value={t.days} label="დღე" />
          <CountUnit testid="countdown-hours" value={t.hours} label="საათი" />
          <CountUnit testid="countdown-minutes" value={t.minutes} label="წუთი" />
          <CountUnit testid="countdown-seconds" value={t.seconds} label="წამი" />
        </div>
      </div>
    </section>
  );
};

export default Header;
